import { createApp } from 'vue'
import Contact from './Contact.vue'
import router from '../../router/mobileMenu.router'

createApp(Contact).use(router).mount('#contact')
